import axios from "axios";
import { Apis, BaseUrl } from "../../config";
import { getSession } from "../authActions";
import { toast } from "react-toastify";
import { type } from "@testing-library/user-event/dist/type";
import { tokenExpired } from "../../../constants/TokenExpired";

export const suggestionList = () => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "suggestion_List_req" });
  try {
    const response = await axios.get(`${BaseUrl}${Apis.suggestionList}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        sys_user_id: user_profile_id,
        role_id: role_id,
      },
    });
    dispatch({ type: "suggestion_List_Success", payload: response.data });
  } catch (error) {
    dispatch({
      type: "suggestion_List_failure",
      payload: error.response.data,
    });

    toast.error(error?.response?.data?.usr?.message);
  }
};

export const deleteSuggestion = (order_id) => async (dispatch) => {
  const { token, role_id, user_profile_id } = getSession();
  dispatch({ type: "suggestion_req_delete" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.deleteSuggestion}${order_id}`, // Update API endpoint as needed
      {
        sys_active_yn: "N", // Make sure this field matches your backend expectation
        sys_user_id: user_profile_id,
        role_id: role_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "suggestion_delete", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    console.log(error);
    dispatch({
      type: "suggestion_delete_failure",
      payload: error.response.data,
    });

    // toast.error(error.response.data);
  }
};

export const facilityList = (view) => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "facility_List_req" });
  try {
    const response = await axios.get(
      `${BaseUrl}${Apis.facilitylist}${user_profile_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { sys_user_id: user_profile_id, role_id: role_id, view: view },
      }
    );
    dispatch({ type: "facility_List_Success", payload: response.data });
    if (response.data) {
      dispatch({ type: "reset_facility_details" });
    }
  } catch (error) {
    dispatch({
      type: "facility_List_failure",
      payload: error?.response?.data,
    });

    const errorMessage = error?.response?.data?.usr?.message;
    toast.error(error?.response?.data?.usr?.message);
    if (errorMessage === "Authentication failed!") {
      tokenExpired();
    }
  }
};

export const deleteFacility = (svcf_id) => async (dispatch) => {
  const { token, role_id, user_profile_id } = getSession();

  dispatch({ type: "facility_req_delete" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.facilitylist}del/${svcf_id}`,
      {
        sys_fac_active_yn: "N",
        sys_user_id: user_profile_id,
        role_id: role_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "facility_delete", payload: response.data });

    toast.success(response.data.usr.message);
  } catch (error) {
    console.log(error);

    dispatch({
      type: "facility_delete_failure",
      payload: error.response.data,
    });

    const errorMessage = error.response.data.usr.message;
    toast.error(error.response.data.usr.message);
    if (errorMessage === "Authentication failed!") {
      tokenExpired();
    }
  }
};

export const createFacility = (values, history) => async (dispatch) => {
  const { token, role_id, user_profile_id } = getSession();

  dispatch({ type: "add_facility_req" });
  try {
    const response = await axios.post(`${BaseUrl}${Apis.newFacility}`, values, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      params: {
        sys_user_id: user_profile_id,
        role_id: role_id,
      },
    });
    dispatch({ type: "add_facility_success", payload: response.data });

    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "add_facility_failure",
      payload: error.response.data.usr.message,
    });

    const errorMessage = error.response.data.usr.message;
    toast.error(error.response.data.usr.message);
    if (errorMessage === "Authentication failed!") {
      tokenExpired();
    }
  }
};
export const createNewDoctor = (values) => async (dispatch) => {
  const { token } = getSession(); // Ensure role_id and user_profile_id are fetched from the session

  try {
    const response = await axios.post(`${BaseUrl}${Apis.newDoctor}`, values, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    toast.success(response.data.usr.message);
  } catch (error) {
    const errorMessage = error.response.data.usr.message;
    toast.error(error.response.data.usr.message);
    if (errorMessage === "Authentication failed!") {
      tokenExpired();
    }
  }
};

export const editfacility = (values, facilityId) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "edit_facility_req" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.newFacility}/${facilityId}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "edit_facility_success", payload: response.data });

    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "edit_facility_failure",
      payload: error.response.data,
    });
    const errorMessage = error.response.data.usr.message;
    toast.error(error.response.data.usr.message);
    if (errorMessage === "Authentication failed!") {
      tokenExpired();
    }
  }
};

export const setCurrentData = (data) => (dispatch) => {
  dispatch({ type: "set_facility_details", payload: data });
};
